import m from 'mithril';
import './app_style.scss';
import { InitialConfigurationData as InitialConfigurationData } from './Models';
import { AppComponents , setupAppComponents} from './app_common_setup';
import { appRootDesktopFsmBuilder, DesktopManifiest } from './states/app_desktop_root';
import { Fsm } from 'little-fsm';
import HotelSearchFormState from './states/HotelSearchFormState';
import { buildHomePresenter } from './presenters/desktop/HomePresenter';
import { buildHotelsPresenter } from './presenters/desktop/HotelsPresenter';

declare global {
    interface Window {
        globalLanguageConfig: any;
    }
}

setupAppComponents("app", (appComponents:AppComponents) => {
    let dataSource = appComponents.dataSource;
    dataSource.authentication(Number(appComponents.branding.agentId), appComponents.branding.channel, "").then(result => {
        if(result.accessToken != null){
            dataSource.fetchInitialConfigurationData(result).then(initialConfigData => {
                initAppUI(appComponents, initialConfigData);
            });
        }
    })
    
});

function initAppUI(appComponents:AppComponents, initialConfigData:InitialConfigurationData) {
    console.log(initialConfigData)

    let appRootElement = appComponents.rootElement;
    let messageProvider = appComponents.messageProvider;
    let extraContentTemplateId:string|null = appRootElement.getAttribute("data-extra-content-template-id");

    let fsm:Fsm<DesktopManifiest> = appRootDesktopFsmBuilder();
    handleRoutingWithHistoryAPI(fsm);


    fsm.init('home', {
        hotelSearchFormState : new HotelSearchFormState()
    });

    let homePresenter = buildHomePresenter(fsm, appComponents, initialConfigData, extraContentTemplateId);
    let hotelsPresenter = buildHotelsPresenter(fsm.subFsm('hotels'), appComponents, initialConfigData);    

    m.mount(appComponents.rootElement, {
        view: function() {
            let currState = fsm.getCurrentState();

            if(currState == 'home') {
                return homePresenter.render();
            } else if(currState == 'hotels') {
                return hotelsPresenter.render();
            } else {
                return m("div", `No screen for the given state ${currState}`);
            }
        }
    });

    if(window.globalLanguageConfig) {
        window.globalLanguageConfig.subscribeChange((lang:string) => {            
            messageProvider.setCurrentLang(lang);
            console.log("Lang changed detected!");
            m.redraw();
        });
    }
}

function handleRoutingWithHistoryAPI(fsm:Fsm<any>) {
    fsm.setStateChangeEffect((oldState, newState, eventName) => {
        console.info(`State changed from ${oldState?.key} to ${newState?.key}`);

        if(eventName != 'back') {
            if(oldState) {            
                window.history.pushState(newState, "", `?state=${newState.key}`);
                console.log(`Pushed state ${newState.key}`)
            } else {    
                window.history.pushState(newState, "", `?state=${newState.key}`)
                console.log(`Replaced state with ${newState.key}`)
            } 
        } else {
            console.log(`Did not push state ${newState.key} to history since back is not allowed`)
        }               
    });

    window.addEventListener('popstate', (event) => {
        console.debug("handling pop state event: ", event);
        console.debug("location.href: ", location.href);
        console.debug("history.state: ", history.state);

        let currState = fsm.getCurrentState();
        fsm.processSubstateEvent(currState, 'back', {});

        m.redraw();
    });
}